import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Store from "@/store";
import { rawApi } from "@/lib";
import { FacilitySavedOrderSearchListResource } from "@/models/api/facility/FacilitySavedOrderSearchListResource";
import * as modals from "../../../lib/modals";
import { IFacility, IFacilityStore } from "@/store/types";

const name = "facility";

if (Store.state[name]) {
  Store.unregisterModule(name);
}

@Module({ name: name, dynamic: true, store: Store, namespaced: true, stateFactory: true })
export default class Facility extends VuexModule implements IFacilityStore {
  facilityOrderSearches: Array<IFacility> = [];
  includeSearchOrderInactiveFacilities: boolean;
  includeSavedSearchInactiveFacilities: boolean;
  includeSearchOrderInactiveExcludeFacilities: boolean;
  includeSavedSearchInactiveExcludeFacilities: boolean;

  get getSubscribedFacilitySavedOrderSearches(): any[] {
    return this.facilityOrderSearches.filter(x => x.subscribed);
  }

  @Mutation
  setFacilityOrderSearches(searches) {
    this.facilityOrderSearches = searches.map(os=>{
      return {
        ...os,
        id: os.id,
        searchName: os.searchName,
        searchFields: os.searchFields.map(sf=>{
          if(sf.name == "RefNumbers"){
            return {
              name: sf.name,
              isDefault: sf.isDefault,
              filterValues: sf.filterValues.map(fv=>JSON.parse(fv))
            }
          }
          return sf
        })
      }
    });;;
  }

  @Mutation
  updateSubscription(payload: any) {
    var selected = this.facilityOrderSearches.filter(x => x.id == payload.searchId);
    if (selected && selected.length > 0) selected[0].subscribed = payload.subscribed;
  }

  @Mutation
  removeFacilitySavedOrderSearch(searchId) {
    let index = this.facilityOrderSearches.findIndex(x => x.id === searchId);
    this.facilityOrderSearches.splice(index, 1);
  }

  @Mutation
  saveSearchOrderIncludeInactiveFacilitiesStatus(status) {
    this.includeSearchOrderInactiveFacilities = status;
  }

  @Mutation
  saveSavedSearchIncludeInactiveFacilitiesStatus(status) {
    this.includeSavedSearchInactiveFacilities = status;
  }

  @Mutation
  saveSearchOrderIncludeInactiveExcludeFacilitiesStatus(status) {
    this.includeSearchOrderInactiveExcludeFacilities = status;
  }

  @Mutation
  saveSavedSearchIncludeInactiveExcludeFacilitiesStatus(status) {
    this.includeSavedSearchInactiveExcludeFacilities = status;
  }

  @Action
  manageFacilitySavedSearchShortcutAction() {
    return this.context.dispatch(
      "system/showModal",
      { name: modals.manageFacilitySavedSearchesModal, data: null },
      { root: true }
    );
  }

  @Action
  getFacilitySavedOrderSearches(): Promise<Array<FacilitySavedOrderSearchListResource>> {
    return rawApi
      .get<Array<FacilitySavedOrderSearchListResource>>("/facilityOrderSearches")
      .then(response => {
        this.setFacilityOrderSearches(response.data);
        this.context.dispatch(
          "account/updateSubscribedSearches",
          this.getSubscribedFacilitySavedOrderSearches,
          { root: true }
        );
        return response.data;
      });
  }

  @Action
  saveFacilityOrderSearch(payload: any): Promise<void> {
    if (payload.id) return rawApi.put(`/facilityOrderSearches/${payload.id}`, payload);

    return rawApi.post("/facilityOrderSearches", payload);
  }

  @Action
  deleteFacilityOrderSearch(searchId: number): Promise<void> {
    return rawApi.delete(`/facilityOrderSearches/${searchId}`).then(() => {
      this.removeFacilitySavedOrderSearch(searchId);
      this.context.dispatch("account/deleteSubscribedOrderSearch", searchId, { root: true });
      return;
    });
  }

  @Action
  updateSearchSubscription(payload: any) {
    this.updateSubscription(payload);
  }

  @Action
  saveSearchOrderIncludeInactiveFacilities(payload: any) {
    this.saveSearchOrderIncludeInactiveFacilitiesStatus(payload);
  }

  @Action
  saveSavedSearchIncludeInactiveFacilities(payload: any) {
    this.saveSavedSearchIncludeInactiveFacilitiesStatus(payload);
  }


  @Action
  saveSearchOrderIncludeInactiveExcludeFacilities(payload: any) {
    this.saveSearchOrderIncludeInactiveExcludeFacilitiesStatus(payload);
  }

  @Action
  saveSavedSearchIncludeInactiveExcludeFacilities(payload: any) {
    this.saveSavedSearchIncludeInactiveExcludeFacilitiesStatus(payload);
  }

  get getSavedSearchInactiveInclude(): boolean {
    return this.includeSavedSearchInactiveFacilities;
  }
}
